import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

if (process.env.VUE_APP_GA4_MEASUREMENT_ID) {
    Vue.use(VueGtag, {
        config: {
            id: process.env.VUE_APP_GA4_MEASUREMENT_ID,
            params: {
                send_page_view: false
            }
        }
    }, router)
}
